var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container__menu"},[_c('MenuOptions'),_c('div',{staticClass:"container__menu__lang",attrs:{"id":"app"}},[_c('LanguageSelector')],1),_c('MenuUserNotifications')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }